module.exports = __webpack_public_path__ + "img/bc.d418f982.svg";